let burger = document.getElementById("burger") as HTMLDialogElement;
let opennav = document.querySelector(".opennav")!;
let closenav = document.querySelector(".closenav")!;

opennav.addEventListener("click", () => {
  document.body.classList.add("lockscroll");
  burger.showModal();
});

closenav.addEventListener("click", () => {
  document.body.classList.remove("lockscroll");
  burger.close();
});

let hasScrolled: boolean;
function updateHasScrolled() {
  const current = scrollY > 0;
  if (hasScrolled !== current) {
    hasScrolled = current;
    document.body.classList.toggle("has-scrolled", current);
  }
}
updateHasScrolled();
addEventListener("scroll", updateHasScrolled, { passive: true });

class ProductHeaderElement extends HTMLElement {
  scaleFactor = 1

  connectedCallback() {
    this.addEventListener("click", this);
    this.addEventListener("package-selected", this);
  }

  handleEvent(event: Event) {
    if (event.type === "click") {
      if ((event.target as HTMLElement).tagName === "IMG") {
        this.toggleZoom(event as MouseEvent);
      }
    } else if (event.type === "package-selected") {
      this.selectPackage((event as CustomEvent).detail.package);
    }
  }

  toggleZoom(event: MouseEvent) {
    if (!window.matchMedia("(min-width: 60em)").matches) {
      return;
    }

    let enlarge = !this.hasAttribute("zoomed");
    let images = this.querySelector(".images")!;
    let bounds = images.getBoundingClientRect();

    if (enlarge) {
      this.scaleFactor = window.innerWidth / bounds.width;
    }

    let scaleFactor = Math.pow(this.scaleFactor, enlarge ? 1 : -1);
    let marginTop = window.scrollY + bounds.top;
    let scrollY = window.scrollY + (event.pageY - marginTop) * (scaleFactor - 1);

    this.toggleAttribute("zoomed");
    window.scrollTo({ top: scrollY, behavior: "instant" });
  }

  selectPackage(pkg: string) {
    let galleries = Array.from(this.querySelectorAll<HTMLElement>(".images-list"));

    for (let gallery of galleries) {
      gallery.classList.toggle("hidden", gallery.dataset.package !== pkg);
    }
  }
}

customElements.define("product-header", ProductHeaderElement);

class PackageSwitcherElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener("change", this);
  }

  handleEvent(event: Event) {
    if (event.type === "change") {
      this.dispatchEvent(new CustomEvent("package-selected", {
        bubbles: true,
        detail: { package: (event.target as HTMLInputElement).value },
      }))
    }
  }
}

customElements.define("package-switcher", PackageSwitcherElement);

class AccordionContainerElement extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this);
  }

  handleEvent(event: Event) {
    if (event.type === "click") {
      const details = (event.target as HTMLElement).closest("details");
      if (details && !details.open) {
        for (const item of Array.from(this.querySelectorAll("details"))) {
          if (item !== details) {
            item.open = false;
          }
        }
      }
    }
  }
}

customElements.define("accordion-container", AccordionContainerElement);
